import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#fff",
  boxShadow: 24,
  borderRadius: "24px",
  outline: "none",

  /* ✅ Responsive widths */
  width: "90%",              // Mobile
  maxHeight: "90vh",
//   overflowY: "auto",

  "@media (min-width: 640px)": {
    width: "70%",             // Tablets
  },

  "@media (min-width: 1024px)": {
    width: "40%",             // Large devices
  },
};

const NewCommonTemplate = ({
  isTemplateOpen = false,
  closeTemplate,
  children,
}) => {
  return (
    <Modal
      open={isTemplateOpen}
      onClose={closeTemplate}
      aria-labelledby="common-modal"
      aria-describedby="common-modal-description"
    >
      <Box sx={modalStyle}>
        {children}
      </Box>
    </Modal>
  );
};

export default NewCommonTemplate;